import styles from './il8n.module.scss';
import il8n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import WebkuaTranslationNOR from './WebkuaTranslationNOR';
import WebkuaTranslationENG from './WebkuaTranslationENG';
import WebkuaTranslationFRA from './WebkuaTranslationFRA';

il8n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: 'no',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      'en-US': {
        translation: WebkuaTranslationENG,
      },
      'en_US': {
        translation: WebkuaTranslationENG,
      },
      'en': {
        translation: WebkuaTranslationENG,
      },
      'fr': {
        translation: WebkuaTranslationFRA,
      },
      'no': {
        translation: WebkuaTranslationNOR,
      },
      'nb-NO': {
        translation: WebkuaTranslationNOR,
      },
      'nb_NO': {
        translation: WebkuaTranslationNOR,
      },
      'nn-NO': {
        translation: WebkuaTranslationNOR,
      },
      'nn_NO': {
        translation: WebkuaTranslationNOR,
      },
      'nb': {
        translation: WebkuaTranslationNOR,
      },
      'nn': {
        translation: WebkuaTranslationNOR,
      }
    }
  });

/* eslint-disable-next-line */

export default il8n;